export default __webpack_public_path__ + "static/media/2.759bb313.png";